import { IconButton, Stack } from '@fluentui/react';
import { EntityDeleteInput } from 'common/types/globalTypes';
import { useState } from 'react';
import { rankOptionType } from '../types';

interface OptionWithEditIconProps {
  option: rankOptionType;
  setRankDeleteEntity: React.Dispatch<
    React.SetStateAction<EntityDeleteInput | undefined>
  >;
  setRankDeleteDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenRankModal: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedOption: React.Dispatch<
    React.SetStateAction<rankOptionType | undefined>
  >;
  currentuserRankId: string | null | undefined;
}

export const OptionWithIcons: React.FC<OptionWithEditIconProps> = ({
  option,
  setRankDeleteEntity,
  setRankDeleteDialog,
  setOpenRankModal,
  setSelectedOption,
  currentuserRankId,
}) => {
  const [hover, setHover] = useState(false);
  return (
    <Stack
      horizontal
      verticalAlign="center"
      tokens={{ childrenGap: 8 }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      styles={{ root: { width: '100%' } }}
    >
      <span>{option?.text}</span>
      {hover && (
        <Stack horizontal style={{ marginLeft: 'auto' }}>
          {option.isUpdatable && (
            <IconButton
              iconProps={{ iconName: 'Edit' }}
              onClick={(e) => {
                e.stopPropagation();
                setOpenRankModal(true);
                setSelectedOption(option);
              }}
            />
          )}
          {currentuserRankId !== option.key.toString() &&
            option.isDeletable && (
              <IconButton
                iconProps={{ iconName: 'Delete' }}
                title="Delete Rank"
                ariaLabel="Delete Rank"
                onClick={(e) => {
                  e.stopPropagation();
                  const selectedItem = option as rankOptionType;
                  setRankDeleteEntity({
                    id: selectedItem.key.toString(),
                    rowTimestamp: selectedItem.rowTimestamp!,
                  });
                  setRankDeleteDialog(true);
                }}
              />
            )}
        </Stack>
      )}
    </Stack>
  );
};
